// **  Initial State
const initialState = {
  data: {
    statistics_total_inspections: {
      stats: [],
      loading: true,
      data: 0
    },
    statistics_average_score: {
      stats: [],
      loading: true,
      data: 0
    },
    statistics_unique_auditors: {
      stats: [],
      loading: true,
      data: 0
    },
    statistics_deficiencies: {
      stats: [],
      loading: true,
      data: 0
    },
    statistics_issues_count: {
      stats: [],
      loading: true,
      data: 0
    },
    total_inspections_bar: {
      stats: [],
      loading: true,
      data: 0
    },
    average_score_bar: {
      stats: [],
      loading: true,
      data: 0
    },
    unique_auditors_bar: {
      stats: [],
      loading: true,
      data: 0
    },
    issues_count_bar: {
      stats: [],
      loading: true,
      data: 0
    },
    inspections_total_score_issues_widget: {
      stats: [],
      loading: true,
      data: 0
    },
    number_questions_responses: {
      stats: [],
      loading: false,
      data: 0
    },
    inspections_table: []
  },
  filters: {

  },
  loading: false
}

export const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_CHARTS_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        }
      }
    case 'ANALYTICS_CHARTS_DATA_WITH_FILTERS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        },
        filters: action.payload.filters
      }
    case 'ANALYTICS_LOADING_START':
      return {
        ...state, loading: true
      }
    case 'ANALYTICS_LOADING_END':
      return {
        ...state, loading: false
      }
    default:
      return state
  }
}
